import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { RoleService } from './@core/services/role.service';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  
  constructor(private authService: AuthService,
               private router: Router,
               private roleService: RoleService,) {}
  // canActivate(
  //   route: ActivatedRouteSnapshot,
  //   state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
  //   return true;
  // }
  // canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // const userRole = this.roleService.getUserRole(); // Fetch user role from AuthService
    // const requiredRole = route.data['role']; // Access role required for the route
    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      const userRole = sessionStorage.getItem('role'); // Get the role from session storage
      const requiredRole = next.data.role; // Get the required role from the route's data

    // if (userRole && userRole === requiredRole) {
    //   return true; // If the role matches, allow access
    // } else {
    //   this.router.navigate(['/login']); // Redirect to login if the role doesn't match
    //   return false;
    // }
    // If the user role matches the required role, allow access
    if (userRole && userRole === requiredRole) {
      return true;
    }

    // If not, redirect to an appropriate route (e.g., login or access denied)
    this.router.navigate(['/login']);
    return false;
  }
  
}
